// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__gwJuR","cabbageIcon":"Loader_cabbageIcon__9HE84","backdrop":"Loader_backdrop__8MJLl"};